export const COLORS = {
    white: '#FFF',
    black: '#000'
}